import * as moment from 'moment'

export class Utility {
   static getDateFromDateTime(date: Date) {
        // let d = moment(date);
        // let hoursDiff = - new Date().getTimezoneOffset() / 60;
        // let minutesDiff = - new Date().getTimezoneOffset() % 60;
        // d.set({
        //     hour: hoursDiff,
        //     minute: minutesDiff,
        //     second: 0,
        //     millisecond: 0
        // });
        // var v1 = d.toDate();
        // return v1.toJSON();
        return moment(date).format("YYYY-MM-DD");
    }

    /**
     * Formats a task due date in a way that's stable across time zones.
     *
     * The API assumes unspecified DateTimes are GMT (see server JSON converter),
     * so sending midnight will shift to the previous day for negative offsets (e.g. -8).
     *
     * We intentionally send noon (12:00) on the selected day to keep the displayed
     * calendar day consistent for typical US time zones.
     */
    static getTaskDueDateFromDateTime(date: Date): string {
        const day = moment(date).format('YYYY-MM-DD');
        return `${day}T12:00:00`;
    }
}

